export default {
  header: {
    title: '💛 Lascia una mancia al team',
    subtitle: 'Il 100% va al personale',
  },
  buttons: {
    other: 'Altro',
    none: 'Nessuna',
  },
  summary_label: 'Mancia',
  form: {
    custom_tip: {
      validation: {
        max: '{{value}} è il valore massimo della mancia',
      },
    },
  },
};
